import {
    rotateLeft,
    rotateRight,
    lock,
    reset,
} from 'redux/appliedFilters/actions'
import {
    areFiltersLocked,
} from 'redux/appliedFilters/selectors'
import {
    toggleImageSettingsAside,
    toggleZoomAside,
} from 'redux/aside/actions'
import {
    areImageSettingsDisplayed,
    isZoomDisplayed,
} from 'redux/aside/selectors'
import { toggleMinimap } from 'redux/minimap/actions'
import { isMinimapEnabled, minimapButtonTitle } from 'redux/minimap/selectors'
import { isResponsiveModeEnabled } from '../redux/visualizer/selectors'

export const filters = {
    image: [
        {
            name: 'reset',
            title: 'visualizer:toolbar.bottom.filters.reset.button',
            action: reset,
            icon: 'fa fa-history fa-2x',
            isDisplayed: state => ! isResponsiveModeEnabled(state)
        },
        {
            name: 'lock',
            title: 'visualizer:toolbar.bottom.filters.lock.button',
            action: lock,
            icon: 'fa fa-unlock-alt fa-2x',
            selectedIcon: 'fa fa-lock fa-2x',
            isSelected: areFiltersLocked,
            isDisplayed: state => ! isResponsiveModeEnabled(state)
        },
        {
            name: 'imageSet',
            title: 'visualizer:toolbar.bottom.filters.imageSet.button',
            action: toggleImageSettingsAside,
            icon: 'fa fa-sliders fa-2x',
            isSelected: areImageSettingsDisplayed,
            isDisplayed: state => ! isResponsiveModeEnabled(state)
        },
        {
            name: 'zoom',
            title: 'visualizer:toolbar.bottom.filters.zoom.button',
            action: toggleZoomAside,
            icon: 'fa fa-search-plus fa-2x',
            isSelected: isZoomDisplayed,
            isDisplayed: state => ! isResponsiveModeEnabled(state)
        },
        {
            name: 'minimap',
            title: minimapButtonTitle,
            action: toggleMinimap,
            icon: 'nf nf-minimap nf-2x',
            isSelected: isMinimapEnabled,
            isDisplayed: state => ! isResponsiveModeEnabled(state)
        },
        {
            name: 'rotateLeft',
            title: 'visualizer:toolbar.bottom.filters.rotateLeft.button',
            action: rotateLeft,
            icon: 'fa fa-rotate-left fa-2x',
            isDisplayed: state => ! isResponsiveModeEnabled(state)
        },
        {
            name: 'rotateRight',
            title: 'visualizer:toolbar.bottom.filters.rotateRight.button',
            action: rotateRight,
            icon: 'fa fa-rotate-right fa-2x',
            isDisplayed: state => ! isResponsiveModeEnabled(state)
        },
    ],
}
